//Styles
import assessStyles from "../../../styles/assessments/Assessment.module.css"
import myStyles from "../../../styles/assessments/AssessmentList.module.css"
import formStyles from "../../../styles/assessments/ManagementForm.module.css"

//PrimeReact
import { Button } from "primereact/button"
import { SelectButton } from "primereact/selectbutton"
import { Badge } from "primereact/badge"
import { Dropdown } from "primereact/dropdown"
import { InputSwitch } from "primereact/inputswitch"
import AssessmentAccessLevels from "../assessmentAccessLevels"
import { OverlayPanel } from "primereact/overlaypanel"
import { useRef } from "react"

export default function AssessmentListHeader({
  inactiveCount,
  hideActiveSelector,
  showSytemTabHelptext,
  showAccessLevelToggles,
  filters,
  additionalFilterCount,
  onFiltersChange,
  onShowFilters,
  disabled,
}) {
  const overlayPanelRef = useRef(undefined)

  const includeEnterpriseShare =
    filters.assessmentLinkShareType === "both" ||
    filters.assessmentLinkShareType === AssessmentAccessLevels.enterprise
  const includePublicShare =
    filters.assessmentLinkShareType === "both" ||
    filters.assessmentLinkShareType === AssessmentAccessLevels.public

  const statusTemplate = (option) => {
    if (option === "active") {
      return <>{option}</>
    } else {
      return (
        <span>
          {option}
          {inactiveCount > 0 ? (
            <Badge className={myStyles.badge} value={inactiveCount || 0} />
          ) : null}
        </span>
      )
    }
  }

  const AccessToggles = () => {
    return (
      <div className={myStyles.AccessToggleContainer}>
        <div
          className={`${myStyles.AccessToggleLayout} ${myStyles.AccessToggleLayoutNoInfo}`}
        >
          <div
            className={`${myStyles.AccessToggleLayoutControl} ${assessStyles.switchControl}`}
          >
            <InputSwitch
              checked={filters.ShowOwnedSharedAssessments}
              onChange={(e) => {
                onFiltersChange({
                  ...filters,
                  ShowOwnedSharedAssessments: e.value,
                })
              }}
              disabled={disabled}
            />
          </div>
          <div className={myStyles.AccessToggleLayoutLabel}>Owned</div>
          <div className={myStyles.AccessToggleLayoutDescription}>
            Show assessments shared by my organization
          </div>
        </div>
        <div
          className={`${myStyles.AccessToggleLayout} ${myStyles.AccessToggleLayoutNoInfo}`}
        >
          <div
            className={`${myStyles.AccessToggleLayoutControl} ${assessStyles.switchControl}`}
          >
            <InputSwitch
              checked={includeEnterpriseShare}
              onChange={(e) => {
                let newShareType = AssessmentAccessLevels.enterprise

                if (e.value && includePublicShare) {
                  newShareType = "both"
                } else {
                  newShareType = AssessmentAccessLevels.public
                }

                onFiltersChange({
                  ...filters,
                  assessmentLinkShareType: newShareType,
                })
              }}
              disabled={disabled}
            />
          </div>
          <div className={myStyles.AccessToggleLayoutLabel}>Enterprise</div>
          <div className={myStyles.AccessToggleLayoutDescription}>
            Shared within my enterprise
          </div>
        </div>

        <div className={myStyles.AccessToggleLayout}>
          <div
            className={`${myStyles.AccessToggleLayoutControl} ${assessStyles.switchControl}`}
          >
            <InputSwitch
              checked={includePublicShare}
              onChange={(e) => {
                let newShareType = AssessmentAccessLevels.public

                if (e.value && includeEnterpriseShare) {
                  newShareType = "both"
                } else {
                  newShareType = AssessmentAccessLevels.enterprise
                }

                onFiltersChange({
                  ...filters,
                  assessmentLinkShareType: newShareType,
                })
              }}
              disabled={disabled}
            />
          </div>
          <div className={myStyles.AccessToggleLayoutLabel}>Public</div>
          <div className={myStyles.AccessToggleLayoutDescription}>
            Shared publicly
          </div>
          <div
            className={`${myStyles.AccessToggleLayoutInfo}`}
            onMouseEnter={(e) => {
              overlayPanelRef.current.show(e)
            }}
            onMouseLeave={(e) => {
              overlayPanelRef.current.hide(e)
            }}
            onClick={(e) => {}}
          >
            <span className={`material-icons`}>info</span>
          </div>
        </div>
        <OverlayPanel
          ref={overlayPanelRef}
          className={assessStyles.InfoOverlayPanel}
        >
          <p className={assessStyles.InfoOverlayText}>
            Public assessments are those created by other RecoveryLink <br />
            enterprises that are available to be used and modified by others.{" "}
            <br />
            <br />
            To add to your enterprise, first clone the public assessment and
            then <br />
            modify it to suit your needs.
          </p>
        </OverlayPanel>
      </div>
    )
  }

  return (
    <div
      className={`${myStyles.listControlLayout} ${
        showSytemTabHelptext ? myStyles.listControlLayoutSystem : ""
      }`}
    >
      <div className={myStyles.listControlLayoutStatus}>
        {!hideActiveSelector ? (
          <SelectButton
            options={["active", "archived"]}
            value={filters?.activeAssessments ? "active" : "archived"}
            onChange={(e) => {
              if (e.value) {
                onFiltersChange({
                  ...filters,
                  activeAssessments: e.value === "active",
                })
              }
            }}
            itemTemplate={statusTemplate}
            disabled={disabled}
          />
        ) : null}
        {showSytemTabHelptext ? (
          <span>
            Changing the On/Off switch will disable the assessment for the
            entire <u>enterprise</u>
          </span>
        ) : null}
      </div>
      {!showSytemTabHelptext ? (
        <>
          <div className={myStyles.listControlLayoutGap} />
          <div className={myStyles.listControlLayoutSearch}>
            {showAccessLevelToggles ? <AccessToggles /> : null}
          </div>
        </>
      ) : null}

      <div className={myStyles.listControlLayoutFilters}>
        <span className="p-input-icon-right">
          <Button
            className={formStyles.mainActionButton}
            onClick={() => {
              onShowFilters()
            }}
            disabled={disabled}
          >
            <span className={`${myStyles.filterButtonText}`}>{`Filters${
              additionalFilterCount > 0 ? ` [${additionalFilterCount}]` : ""
            }`}</span>
            <span className={`material-icons`}>{"tune"}</span>
          </Button>
        </span>
      </div>
      <div className={myStyles.listControlLayoutSort}>
        <Dropdown
          placeholder="Sort by"
          value={filters.sortField}
          options={[
            { label: "New", value: "createdDate" },
            { label: "Activity", value: "dateModified" },
          ]}
          onChange={(e) => {
            onFiltersChange({
              ...filters,
              sortField: e.value,
            })
          }}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
